import styled from "styled-components"
import Colors from "utils/Colors"

export const Button = styled.button`
  position: relative;
  color: #FFFFFF;
  font-size: 12px;
  margin: 0 auto;
  width: fit-content;
  border: 2px solid #888;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  margin: 0 auto;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1rem;
  height: 32px;
  text-transform: capitalize;
  box-shadow: 0px 1px #ddd;
  cursor: pointer;
  &:hover: {
    opacity: 0.9;
  };
`

export const Notification = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -6px;
  right: -9px;
  color: #FFFFFF;
  background-color: ${Colors.red};
  width: 17px;
  height: 17px;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 2px 1px 0px rgb(0 0 0 / 14%), 0px 1px 2px 0px rgb(0 0 0 / 12%);
`

export const DisabledButton = styled.div`
  border-radius: 5px;
  color: ${Colors.loginLigthenPrimaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 10px;
  font-weight: 600;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  width: fit-content;
  border: 2px solid #CCC;
  background-color: #EEE;
  cursor: not-allowed;
  transition: all 250ms easy-in-out;
`
export const LoadingContainer = styled.div`
  width: 112px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`
